import { WidgetHeading } from '../title-widget/WidgetHeading';
import { TeacherCard } from './TeacherCard';
import type { TeachersWidgetResolved } from './types';
import { Carousel } from '@/components/Carousel';

interface TeachersComponentProps {
  resolved: TeachersWidgetResolved;
}

export const TeachersComponent = ({ resolved }: TeachersComponentProps) => {
  const { teachers, heading } = resolved;
  // Covers the Franchise-Partner's "Lehrkräfte-Widget" toggle as well: the
  // resolver answers an off toggle with no teachers, and the heading is dropped
  // with them, so nothing of the widget is left on the page (SH-344 item 2.13).
  if (teachers.length === 0) {
    return null;
  }

  const slides = teachers.map((teacher) => (
    <TeacherCard key={teacher.id} teacher={teacher} />
  ));

  return (
    // The heading sits inside the widget's own root, so the two move and hide
    // together. The root itself carries no spacing: both children bring their
    // own top padding — the heading its editor-chosen `spacing`, the carousel
    // the standard `pt-4` it always had — and padding adds rather than
    // collapsing, so page rhythm is unchanged for a widget with no heading.
    // A wrapper is needed rather than a Fragment (see "Widget Spacing" in
    // CLAUDE.md): `SlotRenderer` needs one element to wrap.
    <div>
      {heading && <WidgetHeading resolved={heading} />}
      <div className="pt-4">
        {/* Desktop: 3 per view */}
        <div className="hidden md:block">
          <Carousel
            slidesPerView={3}
            showArrows={teachers.length > 3}
            slides={slides}
          />
        </div>
        {/* Mobile: 1 per view */}
        <div className="md:hidden">
          <Carousel
            slidesPerView={1}
            showArrows={teachers.length > 1}
            slides={slides}
          />
        </div>
      </div>
    </div>
  );
};
